import styled from 'styled-components';

export const Controls = styled.section`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
`;

export const Control = styled.section`
  display: flex;
  margin: 10px 0;

  input {
    margin: 0 15px;
  }
`;
